<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    :before-close="handleClose"
    custom-class="codeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <!-- 保持原有结构完全不变 -->
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">银行卡支付</div>
        <fm-button
          type="info"
          size="mini"
          text
          icon="icon-model-close"
          style="z-index: 1000;"
          @click="handleClose"
        ></fm-button>
      </div>
      <div class="d-content">
        <div class="card-input-group">
          <div class="topBox">
            <span class="fot">支持的银行卡</span>
            <div class="imgList">
              <img
                v-for="(item, index) in imgList"
                :key="index"
                :src="$utils.getPng(item + '-' + $store.state.theme)"
                class="imgL"
              />
            </div>
          </div>
          <div class="card-box">
            <!-- 仅修改这三个容器的引用方式 -->
            <span class="titleN">卡号</span>
            <div ref="cardNumberContainer" class="card-input-one"></div>
          </div>

          <div class="btBox">
            <div class="card-box">
              <span class="titleN">有效期</span>
              <div ref="expiryContainer" class="twoInput"></div>
            </div>
            <div class="line"></div>
            <div class="card-box">
              <span class="titleN">安全码</span>
              <div ref="cvcContainer" class="threeInput"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-footer">
        <div class="leftBox">
          <span class="leftFont">实付:</span>
          <span class="price">￥{{ cardPayList.new_real_price }}</span>
        </div>
        <fm-button :disabled="!checkPay" @click="PaySignAPI" type="primary" size="small"
          >确认支付</fm-button
        >
      </div>
    </div>
    <div v-if="loading" v-loading="loading" class="flxed"></div>
  </el-dialog>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { getOrderStateAPI } from "@/utils/apiList/vip.js";

export default {
  name: "PayPal",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    cardPayList: {
      type: Object,
      default: {},
    },
    payids: {
      type: String,
      default: "",
    },
    dpayment: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      clientSecret: null,
      loading: true,
      cardNumberComplete: false, // 卡号是否填写完整
      cardExpiryComplete: false, // 有效期是否填写完整
      cardCvcComplete: false,    // 安全码是否填写完整
      checkPay: false,           // 控制支付按钮是否可点击
      imgList: [
        "icon-vip-visa",
        "icon-vip-jcb",
        "icon-vip-unionpay",
        "icon-vip-maestro",
      ],
      domList: [],
      payTimer: null,
    };
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        this.initStripe();
      }
    },
    dpayment(newVal) {
      if (newVal) {
        this.clientSecret = this.dpayment.client_secret;
        this.handlePayment()
      }
    },
    domList(newVal) {
      if (newVal.length == 3) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    },
  },
  methods: {
    Payloading(){
      this.loading = false;
    },
    async initStripe() {
      try {
        // 只初始化一次
        if (this.stripe && this.elements) return;
        this.stripe = await loadStripe(this.$glb.fmstrip);
        this.elements = this.stripe.elements({ locale: "zh" });

        // 创建并挂载卡号
        this.cardNumber = this.elements.create("cardNumber", {
          placeholder: "请输入",
        });
        this.cardNumber.mount(this.$refs.cardNumberContainer);
        this.cardNumber.on("ready", () => {
          this.handleValiready('cardNumber')
        });

        // 创建并挂载有效期
        this.cardExpiry = this.elements.create("cardExpiry", {
          placeholder: "请输入",
        });
        this.cardExpiry.mount(this.$refs.expiryContainer);
        this.cardExpiry.on("ready", () => {
          this.handleValiready('cardExpiry')
        });

        // 创建并挂载CVC
        this.cardCvc = this.elements.create("cardCvc", {
          placeholder: "请输入",
        });
        this.cardCvc.mount(this.$refs.cvcContainer);
        this.cardCvc.on("ready", () => {
          this.handleValiready('cardCvc')
        });

        // 监听验证
        this.cardNumber.on("change", this.handleValidation);
        this.cardExpiry.on("change", this.handleValidation);
        this.cardCvc.on("change", this.handleValidation);
      } catch (error) {
        console.error("Stripe初始化失败:", error);
      }
    },

    handleValiready(ready) {
      // 检查三个元素是否都已完成
      this.domList.push(ready);
    },

    handleValidation(event) {
      // 获取当前输入框的校验状态
      const { elementType, error, complete } = event;
    
      // 更新各个输入框的校验状态
      if (elementType === 'cardNumber') {
        this.cardNumberComplete = complete;
      } else if (elementType === 'cardExpiry') {
        this.cardExpiryComplete = complete;
      } else if (elementType === 'cardCvc') {
        this.cardCvcComplete = complete;
      }
    
      // 检查所有输入框是否都填写正确（无 error 且 complete）
      this.checkPay = this.cardNumberComplete && this.cardExpiryComplete && this.cardCvcComplete;
          
    },

    PaySignAPI: _.debounce(
      function () {
        if (!this.checkPay) {
          return;
        }
        if(!this.clientSecret){
          this.loading = true;
          this.$emit("PaySignAPI", 4);
        } else {
          this.handlePayment()
        }
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),

    async handlePayment() {
      if (!this.clientSecret) {
        this.$message.error("支付信息异常，请刷新重试");
        return;
      }
      this.loading = true;

      try {
        const { error, paymentIntent } = await this.stripe.confirmCardPayment(
          this.clientSecret,
          {
            payment_method: {
              card: this.cardNumber,
              // 可选：billing_details
            },
          }
        );
        if (error) {
          this.$message.error(error.message || "支付失败，请重试");
          this.loading = false;
          return;
        }

        if (paymentIntent && paymentIntent.status === "succeeded") {
          // 立即检查一次
          setTimeout(() => {
            this.checkOrder();
          }, 2000);
          // 轮询订单状态
          this.payTimer = setInterval(() => {
            this.checkOrder();
          }, 4000);
        }
      } catch (error) {
        this.$message.error(error.message || "支付失败，请重试");
      } finally {
        // this.loading = false;
      }
    },

    handleClose() {
      // 清理Stripe元素
      if (this.cardNumber) this.cardNumber.destroy();
      if (this.cardExpiry) this.cardExpiry.destroy();
      if (this.cardCvc) this.cardCvc.destroy();
      this.stripe = null;
      this.elements = null;
      this.cardNumber = null;
      this.cardExpiry = null;
      this.cardCvc = null;
      this.clientSecret = null;
      this.domList = [];
      clearInterval(this.payTimer);
      this.$emit("handleClose");
    },

    checkOrder: _.debounce(
      function () {
        let order = {
          order_id: this.dpayment.out_trade_no,
          pay_type: "cardpay",
          pay_id: this.payids,
        };
        getOrderStateAPI(order)
          .then((res) => {
            if (res.status == 2 || res.status == 1012) {
              this.loading = false;
              clearInterval(this.payTimer);
            }
            if (res.status == 1) {
              this.loading = false;
              this.handleClose();
              this.$emit("openSuccess", res.data.pay_toast);
              clearInterval(this.payTimer);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),
  },
  beforeDestroy() {
    // 组件销毁时清理
    if (this.cardNumber) this.cardNumber.destroy();
    if (this.cardExpiry) this.cardExpiry.destroy();
    if (this.cardCvc) this.cardCvc.destroy();
  },
};
</script>

<style lang="scss" scoped>
.codeDialog {
  .flxed {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 16px;
    ::v-deep .el-loading-mask {
      border-radius: 16px;
    }
  }
  .left {
    height: 24px;
    font-weight: 500;
    font-size: 16px;
    @include useTheme {
      color: getVar("text-color2-2c2c2c");
    }
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .d-footer {
    // margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      display: flex;
      align-items: flex-end;
      .leftFont {
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        margin-right: 2px;
        margin-bottom: 4px;
        @include useTheme {
          color: getVar("text-color1-8a8b92");
        }
      }
    }
    .price {
      font-weight: 600;
      font-size: 24px;
      color: #f67942;
      line-height: 32px;
    }
  }
  .d-content {
    width: 480px;
    margin-left: -24px;
    margin-top: 16px;
    @include useTheme {
      box-shadow: getVar("news-box-shadow3");
    }
    .card-input-one {
      width: 100% !important;
      min-height: 40px;
      margin-bottom: 32px;
    }
    .card-input-group {
      min-height: 192px;
      padding: 20px 24px 32px 24px;
      .topBox {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 32px;
        .fot {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 8px;
          @include useTheme {
            color: getVar("text-color2-2c2c2c");
          }
        }
        .imgList {
          display: flex;
          justify-content: center;
          align-items: center;
          .imgL {
            width: 40px;
            height: 28px;
            margin-right: 16px;
            object-fit: cover;
            -webkit-user-drag: none;
          }
        }
      }
      .card-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .titleN {
          font-weight: 400;
          font-size: 12px;
          white-space: nowrap;
          line-height: 20px;
          margin-bottom: 4px;
          @include useTheme {
            color: getVar("text-color2-2c2c2c");
          }
        }
      }
    }
    .line {
      width: 20px;
    }
    .btBox {
      display: flex;
      width: 100%;
      white-space: nowrap;
      .twoInput {
        width: 206px !important;
        min-height: 40px;
        margin-right: 20px;
      }
      .threeInput {
        width: 206px !important;
        min-height: 40px;
      }
    }
    .card-input {
      width: 100%;
      height: 40px;
      padding-left: 16px;
      border-radius: 8px;
      display: flex;
      align-items: center;
    }
    .StripeElement {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      border: 1px solid transparent;
      padding: 10px 15px;
      @include useTheme {
        background: getVar("text-color1-f6f6f6");
        color: getVar("text-color2-2c2c2c");
      }
      &:hover {
        border: 1px solid $primary-color;
      }
      &:focus {
        border: 1px solid $primary-color;
        @include useTheme {
          background: getVar("bg-color");
          color: getVar("text-color1-2c2c2c");
        }
      }
      .InputElement{
        color: getVar("text-color2-2c2c2c");
        caret-color: $primary-color;
      }
    }
  }
}
</style>    
